module fdm.flightLegs {

    class ExceedanceEventsController {

        public queryResult: any;
        public query: any;
        public link: dg.restfulApi.Link;

        public options = dg.lists.ListOptionsService.getGridOptions({
            type: 'grid',
            //actionColumnEnabled: false,
            useExternalSorting: false,
            useGridScroll: false,
            uiGrid: {
                enableSorting: false,
                columnDefs: [
                    {
                        field: 'status',
                        displayName: '',
                        width: 55
                    },
                    { field: 'aggregate', width: 100 },
                    { field: 'description', width: '25%' },
                    { field: 'phase', minWidth: 55 },
                    { field: 'level', minWidth: 53 },
                    { field: 'second', minWidth: 63 },
                    { field: 'time', minWidth: 60 },
                    { field: 'duration', minWidth: 72, displayName: 'Dur(sec)' },
                    { field: 'parameter', minWidth: 83 },
                    { field: 'unit', minWidth: 50 },
                    { field: 'threshold', minWidth: 62 },
                    { field: 'value', minWidth: 62 },
                    { field: 'exceedance', minWidth: 62 },
                    {field: 'acceptedOrRejectedComment', visible: false},
                    { field: 'smsIntegrationMessage', visible: false },
                    {
                        field: 'smsIntegrationStatus',
                        width: 55,
                        cellClass: 'p-l-sm'
                    },
                   
                    //{ field: 'departure', width: 100 },
                    //{ field: 'arival', width: 100 },
                    //{
                    //    field: 'level',
                    //    cellTemplate: '/app/src/flight-legs/flight-leg-level-grid-template-cell.html'
                    //}
                ]
            },

        });

        public queryManipulator = new dg.actions.ClientQueryManipulator(this.$scope, this.$q, <any>{});

        public constructor(
            public $scope: any,
            private $q: ng.IQService,
            private $element: ng.IAugmentedJQuery,
            protected actionService: dg.actions.ActionService) {
        }
        
        $onChanges(changes) {
            if (changes.queryResult.currentValue) {
                this.queryManipulator.setResult(this.queryResult);
                this.queryManipulator.executeQuery();
            }
            //if (changes.link && changes.link.currentValue) {
            //    this.actionService.getAction(this.link.href).then((result: any) => {
            //        this.queryManipulator = new dg.actions.ServerQueryManipulator(this.$scope, this.$q, result, this.actionService);
            //        this.queryManipulator.executeQuery();
            //    })
            //}
        }
    };

    angular.module('fdm.flightLegs').component('exceedanceEvents', {
        bindings: {
            queryResult: '<',
            link: '<'
        },
        controller: ExceedanceEventsController,
        templateUrl: '/app/src/flight-legs/exceedance-events.html'
    });
}